/**
 * Builds a random Polaroid collage inside `.edited-hero__pile--auto` containers.
 * Runs on every page load/refresh: picks a random subset of the configured
 * images, sizes each to 1/4 of the hero box width, spreads them across
 * shuffled horizontal slots/vertical bands so they don't cluster, and clamps
 * each rotated photo (plus its drop-shadow) fully inside the hero box.
 */
(function () {
  function shuffle(array) {
    for (var i = array.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = array[i];
      array[i] = array[j];
      array[j] = tmp;
    }
    return array;
  }

  function waitForLoad(img) {
    if (img.complete && img.naturalWidth > 0) return Promise.resolve();
    if (img.decode) {
      return img.decode().catch(function () {
        return new Promise(function (resolve) {
          img.addEventListener('load', resolve, { once: true });
          img.addEventListener('error', resolve, { once: true });
        });
      });
    }
    return new Promise(function (resolve) {
      img.addEventListener('load', resolve, { once: true });
      img.addEventListener('error', resolve, { once: true });
    });
  }

  function initPile(pile) {
    if (pile.dataset.polaroidInit) return;
    pile.dataset.polaroidInit = 'true';

    var sourceScript = document.querySelector('script[data-polaroid-source="' + pile.closest('[id^="shopify-section-"]').id.replace('shopify-section-', '') + '"]');
    if (!sourceScript) return;

    var urls;
    try {
      urls = JSON.parse(sourceScript.textContent);
    } catch (e) {
      return;
    }
    if (!urls || !urls.length) return;

    var count = parseInt(pile.getAttribute('data-polaroid-count'), 10) || 6;
    count = Math.min(count, urls.length);
    var selected = shuffle(urls.slice()).slice(0, count);

    var photos = selected.map(function (url, index) {
      var img = document.createElement('img');
      img.className = 'edited-hero__auto-photo';
      img.src = url;
      img.alt = '';
      img.loading = index < 2 ? 'eager' : 'lazy';
      img.decoding = 'async';
      img.setAttribute('aria-hidden', 'true');
      pile.appendChild(img);
      return img;
    });

    Promise.all(photos.map(waitForLoad)).then(function () {
      // Shadow-safe margin: how far the CSS drop-shadow can bleed past the
      // photo's own rotated edge (see filter: drop-shadow in the CSS). Kept
      // inside the safe placement area so the shadow never gets clipped by
      // the hero box's overflow:hidden.
      var SHADOW_PAD = 28;

      var rotations = photos.map(function () {
        return Math.random() * 360;
      });
      var orders = shuffle(photos.map(function (_, i) { return i + 1; }));

      // Spread photos across the box instead of letting pure-random centers
      // cluster: give each photo its own horizontal slot (shuffled) and
      // alternating vertical band, then jitter within that, so a "random"
      // pass never accidentally piles everything in the middle.
      var slots = shuffle(photos.map(function (_, i) { return i; }));

      function layout() {
        var rect = pile.getBoundingClientRect();
        var width = rect.width;
        var height = rect.height;
        if (!width || !height) return;

        var targetHeight = width * 0.25;
        var slotWidth = width / photos.length;
        var bandHeight = height / 2;

        photos.forEach(function (img, i) {
          img.style.height = targetHeight + 'px';
          img.style.width = 'auto';

          var w = img.offsetWidth || targetHeight;
          var h = img.offsetHeight || targetHeight;
          var rad = (rotations[i] * Math.PI) / 180;
          var halfW = (w / 2) * Math.abs(Math.cos(rad)) + (h / 2) * Math.abs(Math.sin(rad)) + SHADOW_PAD;
          var halfH = (w / 2) * Math.abs(Math.sin(rad)) + (h / 2) * Math.abs(Math.cos(rad)) + SHADOW_PAD;

          var minX = halfW;
          var maxX = width - halfW;
          var slotIndex = slots[i];
          var slotCenter = slotWidth * (slotIndex + 0.5);
          var targetX = slotCenter + (Math.random() - 0.5) * slotWidth * 0.85;
          var cx = minX <= maxX ? Math.min(Math.max(targetX, minX), maxX) : width / 2;

          var minY = halfH;
          var maxY = height - halfH;
          var band = slotIndex % 2;
          var bandCenter = bandHeight * (band + 0.5);
          var targetY = bandCenter + (Math.random() - 0.5) * bandHeight * 0.9;
          var cy = minY <= maxY ? Math.min(Math.max(targetY, minY), maxY) : height / 2;

          img.style.left = cx + 'px';
          img.style.top = cy + 'px';
          img.style.transform = 'translate(-50%, -50%) rotate(' + rotations[i] + 'deg)';
          img.style.zIndex = orders[i];
          img.classList.add('is-visible');
        });
      }

      layout();

      var resizeTimer;
      var observer = new ResizeObserver(function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(layout, 120);
      });
      observer.observe(pile);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.edited-hero__pile--auto').forEach(initPile);
  });
})();
